var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M24.7091 51.395C38.3556 51.395 49.4183 40.3324 49.4183 26.6859C49.4183 13.0394 38.3556 1.97673 24.7091 1.97673C11.0627 1.97673 0 13.0394 0 26.6859C0 40.3324 11.0627 51.395 24.7091 51.395Z",
    fill: "url(#paint0_radial_54_307)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8503 24.8815V8.79185C1.85636 6.46197 2.78461 4.22926 4.43209 2.58178C6.07957 0.934301 8.31228 0.00606743 10.6422 0H26.7318C29.0597 0.00909736 31.2895 0.938666 32.9345 2.58582C34.5795 4.23297 35.5061 6.46396 35.5122 8.79185V24.8815C35.5061 27.2094 34.5795 29.4404 32.9345 31.0876C31.2895 32.7347 29.0597 33.6643 26.7318 33.6734H21.3418L18.5146 32.9838L16.0897 33.6734H10.6422C8.31321 33.6643 6.08223 32.7351 4.4354 31.0883C2.78857 29.4415 1.85938 27.2105 1.8503 24.8815Z",
    fill: "#005A92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1918 22.2727L25.9388 17.4113H21.3418V14.3083C21.3093 13.946 21.3587 13.581 21.4864 13.2404C21.6142 12.8998 21.8168 12.5923 22.0795 12.3406C22.3422 12.089 22.6581 11.8997 23.0039 11.7867C23.3497 11.6737 23.7164 11.64 24.077 11.688H26.1917V7.55065C24.949 7.34646 23.6928 7.23505 22.4336 7.21737C18.595 7.21737 16.0897 9.51588 16.0897 13.7567V17.4113H11.8259V22.2727H16.0897V33.6734H21.3418V22.2727H25.1918Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54_307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7091 26.6859) scale(24.7091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook Icon.c4fdad8e537b2d0467b20c33598dcc73.svg";
export { ForwardRef as ReactComponent };